import type { Dictionary } from '../types';

export const fr: Dictionary = {
  doc_title: "BITSECURE — Audits de sécurité & tests d'intrusion pour les entreprises",

  nav_services: 'Services',
  nav_why: 'Pourquoi nous',
  nav_process: 'Méthode',
  nav_contact: 'Contact',
  nav_cta: 'Demander conseil',

  hero_h1: "Une protection d'entreprise digne de confiance",
  hero_lead:
    "BITSECURE réalise des audits indépendants et des tests d'intrusion, identifiant les faiblesses de vos systèmes avant qu'elles ne soient exploitées. Rapports clairs, recommandations concrètes, confidentialité stricte.",
  hero_cta1: 'Demander conseil →',
  hero_cta2: 'Nos services',
  hero_note: 'Nous travaillons sous contrat et NDA · première consultation gratuite',

  chip1_t: 'Audit réussi',
  chip1_s: '0 critique',
  chip2_t: 'NDA',
  chip2_s: 'confidentiel',
  chip3_t: 'Rapport + plan',
  chip3_s: 'étapes claires',

  trust1_l: 'tests réalisés',
  trust2_l: 'secteurs & entreprises',
  trust3_l: 'respect du NDA',
  trust4_l: "support après l'audit",

  svc_h2: 'Évaluation complète de la sécurité',
  svc_p:
    "Une gamme complète de services — de l'audit ciblé d'une application à la simulation à grande échelle d'une attaque ciblée contre votre entreprise.",

  why_h2: 'Un partenaire, pas un prestataire',
  why_p: 'Nous répondons du résultat : nous identifions les risques réels et aidons à les éliminer.',

  proc_h2: 'Un processus clair à chaque étape',

  std_lab: 'Nous suivons des <b>méthodologies de test internationales</b> reconnues',

  contact_h2: 'Parlons de la sécurité de votre entreprise',
  contact_p:
    'Contactez notre équipe — nous évaluerons vos besoins et conviendrons du périmètre et des délais. La première consultation est gratuite.',

  foot_tagline: "Audits indépendants de sécurité de l'information et tests d'intrusion pour les entreprises.",
  foot_services: 'Services',
  foot_company: 'Entreprise',
  foot_connect: 'Contact',
  foot_s1: 'Applications web',
  foot_s2: 'Périmètre externe',
  foot_s3: 'Red Team',
  foot_s4: 'Audit du code',
  foot_s5: 'Ingénierie sociale',
  foot_rights: '© 2025 BITSECURE. Tous droits réservés.',
  foot_privacy: 'Politique de confidentialité',
  foot_offer: 'Conditions générales',

  pop_title: 'Nous contacter',
  pop_sub: 'Choisissez le canal qui vous convient — réponse rapide.',

  order: 'Commander',

  form_title: 'Faire une demande',
  form_sub: 'Remplissez le formulaire — réponse sous un jour.',
  f_company: "Nom de l'entreprise",
  f_email: 'Adresse e-mail',
  f_method: 'Moyen de contact préféré',
  f_m_tg: 'Telegram',
  f_m_phone: 'Téléphone',
  f_m_wa: 'WhatsApp',
  f_contact_tg: 'Identifiant Telegram',
  f_contact_phone: 'Numéro de téléphone',
  f_contact_wa: 'Numéro WhatsApp',
  f_service: 'Service souhaité',
  f_comments: 'Commentaires supplémentaires',
  f_submit: 'Envoyer la demande',
  f_succ_t: 'Demande envoyée !',
  f_succ_s: 'Merci ! Nous vous contacterons sous peu.',
  f_close: 'Fermer',

  ch_phone_t: 'Téléphone',
  ch_phone_s: 'sur demande',
  ch_wa_s: 'réponse rapide',

  services: [
    ['Applications web', 'Nous détectons les vulnérabilités des applications web selon la méthodologie OWASP — avant les attaquants.'],
    ['Périmètre externe', 'Nous testons la résistance de votre infrastructure externe aux intrusions depuis Internet.'],
    ['Réseau interne', "Nous simulons une attaque interne : ce qu'un intrus pourrait faire une fois dans le réseau."],
    ['Red Team', "Simulation complète d'une attaque ciblée réelle — test de la réactivité de vos équipes et processus."],
    ['Applications mobiles', 'Audit iOS et Android : stockage des données, logique métier, sécurité des API.'],
    ['Audit du code source', 'Nous recherchons les vulnérabilités au niveau du code — analyse statique et revue manuelle.'],
    ['Réseaux sans fil', "Test du Wi-Fi contre l'interception du trafic et les accès non autorisés."],
    ['Ingénierie sociale', 'Nous testons les employés face au phishing et à la manipulation, révélant les failles des politiques.'],
    ['Conseil & processus', 'Nous construisons des processus sécurisés et une stratégie de protection des données.'],
  ],
  why: [
    ['01', 'Confidentialité', 'Respect strict du NDA et protection des données client à chaque étape.'],
    ['02', 'Expertise', "Des spécialistes expérimentés appliquent des techniques avancées et la logique d'un vrai attaquant."],
    ['03', 'Recommandations concrètes', "Des étapes de correction précises — un plan d'action clair, pas un rapport abstrait."],
    ['04', 'Approche sur mesure', 'Nous adaptons les scénarios à votre infrastructure, vos risques et vos ressources.'],
  ],
  steps: [
    ['01', 'Analyse des besoins', 'Nous analysons en détail les exigences, les actifs et les objectifs pour choisir la bonne approche.'],
    ['02', 'Conception des solutions', 'Nous élaborons une stratégie et des scénarios de test sur mesure.'],
    ['03', 'Exécution & support', 'Nous réalisons les travaux et accompagnons la correction des problèmes identifiés.'],
    ['04', 'Retour & amélioration', 'Nous améliorons continuellement nos services selon les résultats et les besoins du client.'],
  ],
};
